<template lang="pug">
    .box
        v-server-table(
            :url='""'
            :name='tableName'
            ref='datatable'
            :columns='columns'
            :options='options'
        )
            template(slot='beforeTable')
                datatable-loader(:name='tableName')

            template(slot="afterTable")
                es-table-pagination(
                    ref="nav"
                    :count="count"
                    :totalRecords="totalRecords"
                    :isLoading="isLoading"
                    @limit-change="setLimit"
                    @navigate="setAfterKey"
                )

        receipt(ref="receipt")
</template>

<script>
const TableName = 'VUETABLE_VOIDED_RECEIPT_ES';

import { mapState } from 'vuex';
import receiptMixin from '@js/mixins/receipt';
import tillFilterMixin from '../../../components/till-filter/till-filter-mixin';

export default {
    mixins: [receiptMixin, tillFilterMixin],

    data() {
        let columns = [
            'voided_at',
            'settled_date',
            'sequence_number',
            'voider',
            'void_remarks',
            'till_closure',
            'till_summary',
            'cashier',
            'payment_type',
            'total_amount',
            'outlet_name',
        ];

        return {
            tableName: TableName,
            afterKey: null,
            count: 0,
            isLoading: true,
            totalRecords: 0,
            columns,
            options: {
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until', 'filters'],
                sortable: ['settled_date'],
                footer: false,
                rowClassCallback: row => 'pointer',
                texts: {
                    title: 'Voided Receipts',
                    description: 'Shows list of voided C-store',
                },
                initFilters: {
                    outlet_id: this.$store.getters.activeOutlet,
                    since: this.$store.getters.startDate.format(),
                    until: this.$store.getters.endDate.format(),
                },
                headings: {
                    settled_date: 'Receipt Date',
                    sequence_number: 'Receipt No.',
                    outlet_name: this.trans('general.outlet'),
                    voider: 'Voided By',
                    void_remarks: 'Reason',
                    payment_type: 'Payment Type',
                    total_amount: 'Total Amount (RM)',
                    till_closure: 'Till Closure No.',
                    till_summary: 'Till Summary No.',
                    voided_at: 'Voided At',
                },
                orderBy: {
                    column: 'settled_date',
                    ascending: 0,
                },
                templates: {
                    sequence_number: (h, row) => {
                        return this.receiptNumberFormat(row);
                    },
                    settled_date: (h, row) => {
                        return this.receiptDateFormat(row.settled_date);
                    },
                    voided_at: (h, row) => {
                        return this.receiptDateFormat(row.voided_at);
                    },
                    outlet_name: (h, row) => {
                        return row.outlet_name.substring(0, 20);
                    },
                },
                columnsClasses: {
                    total_amount: 'text-right',
                    balance: 'text-right',
                    amount: 'text-right',
                    terminal_type: 'text-left',
                },
                responseAdapter: resp => {
                    this.totalRecords = resp.data.count;
                    return resp.data;
                },
                requestFunction: async data => {
                    if (data.afterKey && data.afterKey === this.afterKey) {
                        data.afterKey = null;
                        this.resetPagination();
                    }

                    try {
                        const response = await axios.get(
                            Laroute.route(
                                'franchise.report.voidedsales.es.voidedReceiptList',
                            ),
                            {
                                params: data,
                            },
                        );

                        this.$refs.nav.afterKey = response.data.afterKey;

                        return response;
                    } catch (e) {
                        this.dispatch('error', e);
                    }
                },
                rowClickCallback: row => {
                    this.showReceipt(row.id, null, true);
                },
                pdf_url: Laroute.route(
                    'franchise.report.voidedsales.es.voidedReceiptExport',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.voidedsales.es.voidedReceiptExport',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.voidedsales.es.voidedReceiptExport',
                    { type: 'XLSX' },
                ),
            },
        };
    },

    computed: {
        ...mapState('tillFilter', ['filters']),

        getActiveOutlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;

            this.setFilter();
        },

        getActiveOutlet() {
            this.setColumnDisplay();
        },
    },

    mounted() {
        this.setColumnDisplay();

        this.$watch(
            () => this.$refs.datatable.tableData.length,
            data => {
                this.count = data;
            },
        );

        this.createVuexSubscription(`${TableName}/LOADING`, () => {
            this.isLoading = true;
        });

        this.createVuexSubscription(`${TableName}/LOADED`, () => {
            this.isLoading = false;
        });

        this.createVuexSubscription(`${TableName}/ERROR`, () => {
            this.isLoading = false;
        });
    },

    methods: {
        setLimit(limit) {
            this.$refs.datatable.setLimit(limit);
        },

        setAfterKey(afterKey) {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'afterKey',
                value: afterKey,
            });

            this.afterKey = afterKey;
        },

        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },

        resetPagination() {
            this.$refs.nav.$emit('reset-es-pagination');
        },

        showReceipt(transaction_id, refund_id = null, voided = false) {
            this.$refs.receipt.$emit(
                'show-receipt',
                transaction_id,
                refund_id,
                voided,
            );
        },

        setColumnDisplay() {
            if (this.getActiveOutlet != 0) {
                this.$refs.datatable.userControlsColumns = true;
                this.$refs.datatable.userColumnsDisplay = [
                    'voided_at',
                    'settled_date',
                    'sequence_number',
                    'voider',
                    'void_remarks',
                    'till_closure',
                    'till_summary',
                    'cashier',
                    'payment_type',
                    'total_amount',
                ];
            } else {
                this.$refs.datatable.userColumnsDisplay = this.columns;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/voided/es-report/voided-receipt-datatable.vue